import { observer } from 'mobx-react-lite';

import { CartItemList } from '../CartItemList';
import {
  ICartItem,
  ItemDetails,
  useCartContext,
} from 'screens/AccessExpressV3/CartProvider';
import EmptyCart from './EmptyCart';
import { useNavigate } from 'react-router-dom';
import { ItemSubtype } from 'screens/AccessExpressV3/accessExpress.types';

const ProductBody = observer(({ items }: { items: ICartItem[] }) => {
  const cart = useCartContext();
  const navigate = useNavigate();

  const handleEdit = (id: ICartItem['id']) => {
    const mainItem = cart.items.find((item) => item.id === id);
    const allRelatedItems = cart.items.filter(
      (item) =>
        item.item_details?.parentId === mainItem?.item_details?.referenceId,
    );

    const simOption = allRelatedItems.find(
      (item) => item.item_details?.subtype === ItemSubtype.SIM,
    );
    const planOption = allRelatedItems.find(
      (item) => item.item_details?.subtype === ItemSubtype.PLAN,
    );

    const additionalSimOption = allRelatedItems.find(
      (item) =>
        item.item_details?.subtype === ItemSubtype.SIM &&
        item.item_details?.secondaryPlan,
    );
    const additionalPlanOption = allRelatedItems.find(
      (item) =>
        item.item_details?.subtype === ItemSubtype.PLAN &&
        item.item_details?.secondaryPlan,
    );

    if (mainItem) {
      navigate(`product/${mainItem.item_details?.graniteId}`, {
        state: {
          selected: {
            dataPlanNeededActivation: (
              mainItem.item_details as {
                dataPlanNeeded?: { activation: string };
              }
            )?.dataPlanNeeded?.activation,
            choosePricingOptionId: mainItem.item_details?.pimProductPricingId,
            simOptionId:
              simOption?.item_details?.pim_product_pricing_id ?? null,
            planTypeOptionId:
              planOption?.item_details?.pim_product_pricing_id ?? null,
            additionalSimOptionId:
              additionalSimOption?.item_details?.pim_product_pricing_id ?? null,
            additionalPlanTypeOptionId:
              additionalPlanOption?.item_details?.pim_product_pricing_id ??
              null,
            globalOrderCarrier:
              (
                mainItem.item_details as {
                  global?: { orderCarrier: string[] };
                }
              )?.global?.orderCarrier.join(',') || '',
            globalCoverage: (
              mainItem.item_details as {
                global?: { coverage: string };
              }
            )?.global?.coverage,
            additionalGlobalOrderCarrier:
              (
                mainItem.item_details as {
                  additionalGlobal?: { orderCarrier: string[] };
                }
              )?.additionalGlobal?.orderCarrier.join(',') || '',
            additionalGlobalCoverage: (
              mainItem.item_details as {
                additionalGlobal?: { coverage: string };
              }
            )?.additionalGlobal?.coverage,
          },
        },
      });
      cart.close();
    }
  };

  const handleDelete = (item: ICartItem) => {
    if (item.category === 'Access') {
      if (item.subtype === 'starlink') {
        cart.removeStarlinkCartItem(
          item.item_details as ItemDetails,
          item.locationId as string,
        );
      } else
        cart.removeAccessCartItem(
          item.item_details?.offering_id ?? '',
          item.locationId as string,
        );
    } else if (item.category === 'Mobility') {
      cart.removeMobilityCartItem(String(item?.id));
    }
  };

  const handleQuantityChange = (item: ICartItem, newQty: number) => {
    if (item.category === 'Access' && item.subtype === 'starlink') {
      cart.updateStarlinkItemQuantity(item, newQty);
      return;
    }
    cart.updateItemQuantity(item.id, newQty);
  };

  return (
    <>
      {items.length ? (
        <CartItemList
          items={items}
          onEdit={handleEdit}
          onDelete={handleDelete}
          onQuantityChange={handleQuantityChange}
          disable={{
            onEdit: (item) => item.category !== 'Mobility',
          }}
        />
      ) : (
        <EmptyCart />
      )}
    </>
  );
});

export default ProductBody;
